import React from "react";
import "./TnsDriving.css";

function TnsDriving({ bgImage, operationsData = [] }) {
  return (
    <section
      className=" section-padding tnsDriving-section "
      style={{
        backgroundImage: bgImage ? `url(${bgImage})` : "none",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      {operationsData.map((item, index) => (
        <div
          key={item.id}
          className={`row align-items-center  ${
            index % 2 !== 0 ? "flex-row-reverse" : ""
          }`}
        >
          {/* Text Content */}
          <div className="col-lg-6 col-md-12">
            <div className="tnsDriving-content">
              <h2 className="heading-title text-start about-title">
                {item.title}
                <span className="title-blue">{item.highlight}</span>{" "}
              </h2>
              {item.paragraphs?.map((text, i) => (
                <p key={i} className="sub-text ">
                  {text}
                </p>
              ))}
              <div
                className="tnsDriving-image-wrapper image-none"
                style={{
                  backgroundImage: item.image ? `url(${item.image})` : "none",
                  backgroundPosition: item.bgPosition,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                }}
              ></div>
              {/*  List Section */}
              {item.list && item.list.length > 0 && (
                <>
                  {item.listHeading && (
                    <h4 className="tnsDriving-list-heading">
                      {item.listHeading}
                    </h4>
                  )}

                  <ul className="tnsDriving-list mt-3">
                    {item.list.map((point, i) => (
                      <li key={i} className="tnsDriving-list-item">
                        <img
                          src="/assets/tns-check.svg"
                          alt="check"
                          className="tns-check-icon"
                        />
                        <p>{point}</p>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>

          {/* Image */}
          <div className="col-lg-6 col-md-12 mb-lg-0 image-flex">
            <div
              className="tnsDriving-image-wrapper"
              style={{
                backgroundImage: item.image ? `url(${item.image})` : "none",
                backgroundPosition: item.bgPosition,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
              }}
            ></div>
          </div>
        </div>
      ))}
    </section>
  );
}

export default TnsDriving;
